import { render, staticRenderFns } from "./SendAlert.vue?vue&type=template&id=360c496c&scoped=true&"
import script from "./SendAlert.vue?vue&type=script&lang=js&"
export * from "./SendAlert.vue?vue&type=script&lang=js&"
import style0 from "./SendAlert.vue?vue&type=style&index=0&id=360c496c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c496c",
  null
  
)

export default component.exports